import { render, staticRenderFns } from "./ReceiptPrint.vue?vue&type=template&id=48cfdab0"
import script from "./ReceiptPrint.vue?vue&type=script&lang=js"
export * from "./ReceiptPrint.vue?vue&type=script&lang=js"
import style0 from "./ReceiptPrint.vue?vue&type=style&index=0&id=48cfdab0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports